module.exports = __webpack_public_path__ + "img/problem.36c26fbf.png";